@charset "UTF-8";

/* src/app/forms/gridview/gridview.component.scss */
.content {
  padding: 5px;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.view-component {
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface);
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: var(--tem-radius);
  margin: 2px;
  font-family: var(--tem-font-family);
}
.screen-spin,
.items-spin {
  height: 100%;
  display: block;
}
:host ::ng-deep .screen-spin > .ant-spin-container,
:host ::ng-deep .items-spin > .ant-spin-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.no-record {
  display: flex;
  flex-direction: column;
  height: 100%;
  align-items: center;
  justify-content: center;
  color: var(--tem-muted);
}
.title {
  width: 100%;
  padding: 6px;
  text-align: right;
  font-size: 100%;
}
.filter-collapse {
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: var(--tem-radius);
}
.filter-title {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
  color: var(--tem-ink);
}
.filter-actions {
  display: inline-flex;
  align-items: center;
  gap: var(--tem-space-2);
}
.filter-select {
  width: 100%;
  max-width: 480px;
}
.tableclass-opened,
.tableclass-closed {
  cursor: pointer;
  width: 100%;
  max-width: 100%;
  overflow: auto;
  border-collapse: collapse;
  margin: 0px;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
}
.chip-list {
  margin: 10px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 400px;
  min-width: 40%;
}
.fast-filter-detail {
  width: 100%;
}
.fast-filter-select {
  width: 100%;
}
.table-relative {
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;
}
.innertable {
  display: flex;
  height: 100%;
  overflow: auto;
  margin: 5px;
}
.flex-spacer {
  flex-grow: 1;
}
.filterclass {
  margin-top: 8px;
}
.filterclass2 {
  padding: 0 10px 6px 10px;
}
.vl {
  border-left: 1px solid var(--tem-border);
  height: 30px;
  width: 10px;
  margin-left: 10px;
}
.paginator {
  border-radius: var(--tem-radius);
  border: 1px solid var(--tem-border);
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface-2);
  width: 100%;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  align-items: center;
  margin: 10px;
  padding-left: 10px;
  padding-right: 10px;
  height: 50px;
}
.info {
  text-align: center;
  font-weight: 500;
  align-self: center;
  margin-right: 6px;
  color: var(--tem-ink);
}
.info.data {
  box-shadow: var(--tem-shadow);
  background: var(--tem-surface-2);
  border: 1px solid var(--tem-border);
  border-radius: 50%;
  height: 40px;
  width: 40px;
  line-height: 20px;
  margin-left: 10px;
}
.total-lines {
  height: 40px;
  width: 40px;
  line-height: 40px;
  text-align: center;
}
.data-info {
  display: flex;
  flex-direction: row;
  width: 100%;
  align-items: center;
  padding-top: 4px;
  padding-bottom: 4px;
}
.cancelar {
  color: var(--tem-deep);
  cursor: pointer;
  text-decoration: underline;
}
.counter {
  font-size: small;
  font-weight: 500;
}
.fast-filter {
  display: flex;
  width: 100%;
  flex-direction: row;
  margin-top: 4px;
  padding-right: 10px;
  padding-left: 10px;
  gap: var(--tem-space-2);
}
.fast-filter-option {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: var(--tem-space-2);
}
p {
  margin-bottom: 0;
}
.fast-filter-option b {
  max-width: 200px;
  text-overflow: ellipsis;
  overflow: hidden;
  min-width: 200px;
}
.fast-filter-option-icon {
  display: inline-flex;
  max-width: 40px;
  min-width: 24px;
}
.add-button {
  position: absolute;
  bottom: 30px;
  right: 60px;
}
.add-button button {
  box-shadow: var(--tem-shadow);
}
.copy-button {
  margin-left: 10px;
  margin-right: 10px;
}
.classe-border {
  border-radius: var(--tem-radius);
}
/*# sourceMappingURL=gridview.component.css.map */
